import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars'
import cn from 'classnames'
import * as Sentry from '@sentry/browser'

import NotificationsListItem from 'app/domains/routes/Notifications/NotificationsList/NotificationsListItem'
import NotificationsListLoader from 'app/domains/common/Loaders/NotificationsListLoader'
import NotificationsListItemLoader from 'app/domains/common/Loaders/NotificationsListItemLoader'
import NotificationsEmptyList from 'app/domains/routes/Notifications/NotificationsEmptyList'

const bc = 'notifications-list'

class NotificationsList extends Component {
  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      scope.setExtra('errorInfo', errorInfo)
      scope.setExtra('where error was happen', 'NotificationsList')
      scope.setExtra('notificationsList', JSON.stringify(this.props.notificationsList))
      scope.setExtra('user', this.props.user)
      Sentry.captureException(error)
    })
  }

  componentDidMount() {
    this.props.isMobileOnly && window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    this.props.isMobileOnly && window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    this.props.handleScroll({ currentTarget: document.body })
  }

  renderList = () => {
    const { pending, notificationsList } = this.props

    if (pending) {
      return <NotificationsListLoader />
    }

    if (notificationsList.size) {
      return notificationsList.map((item, index) => {
        const notification = item.toJS()
        return <NotificationsListItem notification={notification} key={index} />
      })
    }

    return <NotificationsEmptyList />
  }

  render() {
    const { pendingMore, handleScroll, isMobileOnly } = this.props
    return (
      <div className={cn(bc, { [`${bc}--mobile`]: !isMobileOnly })}>
        {isMobileOnly ? (
          this.renderList()
        ) : (
          <Scrollbars
            onScroll={handleScroll}
            autoHeight
            autoHeightMax={382}
            renderThumbVertical={props => <div {...props} className="scrollbar-thumb-vertical" />}
          >
            {this.renderList()}
          </Scrollbars>
        )}
        {pendingMore ? <NotificationsListItemLoader /> : null}
      </div>
    )
  }
}

NotificationsList.propTypes = {
  notificationsList: ImmutablePropTypes.list,
  handleScroll: PropTypes.func.isRequired,
  pending: PropTypes.bool.isRequired,
  pendingMore: PropTypes.bool.isRequired,
  identity: PropTypes.object.isRequired,
  isMobileOnly: PropTypes.bool.isRequired,
}

export default NotificationsList
